'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function isObject(value) {
  return value && (typeof value === 'undefined' ? 'undefined' : _typeof(value)) === 'object' && value.constructor === Object;
}

exports.default = function (initialState) {
  return {
    set: function set(state, action) {
      if (!isObject(initialState)) {
        console.error('@redux-modux: Cannot use set because initialState is not an Object');
        return state;
      }

      if (!action.hasOwnProperty('key') || !action.hasOwnProperty('value')) {
        console.error('@redux-modux: set is require "key" and "value"');
        return state;
      }

      if (!initialState.hasOwnProperty(action.key)) {
        console.error('@redux-modux: ' + action.key + ' is not defined in initialState');
        return state;
      }

      return _extends({}, state, _defineProperty({}, action.key, action.value));
    },
    resetDefault: function resetDefault() {
      return initialState;
    }
  };
};